import BorderedProfilePhoto from '../ui/bordered-profile-photo'

type TeamInvitationIconProps = {
  mapSnapshot: string
  referredByProfilePhoto: string
}

const TeamInvitationIcon = ({ mapSnapshot, referredByProfilePhoto }: TeamInvitationIconProps) => {
  if (!referredByProfilePhoto) {
    return <BorderedProfilePhoto uri={null} size={45} borderWidth={2} />
  }

  if (!mapSnapshot) {
    return <BorderedProfilePhoto uri={referredByProfilePhoto} size={45} borderWidth={2} />
  }

  return (
    <div className="relative flex size-[49px] items-center justify-center rounded-[10px] border-2 border-white bg-white shadow-[0_2px_12px_rgba(27,48,41,0.1)]">
      <img src={mapSnapshot} alt="" className="size-full rounded-[10px] bg-lightBorder object-cover" />
      <div className="absolute -bottom-1 -right-1">
        <BorderedProfilePhoto uri={referredByProfilePhoto} size={25} borderWidth={2} />
      </div>
    </div>
  )
}

export default TeamInvitationIcon
